import { OrderConfirmViewEvent } from '@/usecases/event-bus-for-third-party/event'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { smbOrderConfirmViewEventFactory } from '@/vendor/gtm/events/gp/smb-order-confirm-view'

/**
 * MyColor独自: 注文確認画面閲覧イベント
 */
export function handleOrderConfirmViewEvent(event: OrderConfirmViewEvent): void {
  const dataLayerService = new DataLayerService()
  const orderConfirmViewEvent = smbOrderConfirmViewEventFactory.createFromOrderConfirmViewEvent(event)

  dataLayerService.push(orderConfirmViewEvent)
}
